<template>
    <router-link :to="linkToPage" class="item wrap" :class="classItem">
        <p class="identification">
            <span>
                Distributeur
                <strong class="distributeur">{{ bouteille.fournisseur.nom }}</strong>
            </span>
            <br> Bouteille
            <strong class="nom">{{ bouteille.nom.nom }}</strong>
            <template v-if="bouteille.marque">
                <br>
                <span>
                    Marque
                    <strong class="marque">{{ bouteille.marque }}</strong>
                </span>
            </template>
        </p>
        <div class="floating">

            <div class="favori"
                v-if="bouteille.favori !== null && bouteille.favori != undefined && $user && bouteille.favori.id === $user.id">
                <i class="icon-star"></i>
            </div>

            <div class="id-bouteille">
                <i class="icon-gas"></i>
                {{ bouteille.code }}
            </div>

            <div class="refrigerant" v-if="bouteille.fluide" :class="bouteille.fluide.regenerated ? 'regen' : ''">
                <i class="icon-fluid"></i>
                {{ bouteille.fluide.nom }}
            </div>

            <div v-if="bouteille.type !== 'Fluide frigorigène' && bouteille.poids_net !== 0" class="refrigerant"
                style="color: orange;">
                <i class="icon-link"></i>
                {{ info }}
            </div>

            <div class="otag" v-if="bouteille.otag">
                <i class="icon-otag"></i>
                {{ bouteille.otag }}
            </div>

            <div class="clear"></div>
        </div>
        <span v-if="bouteille.otag" class="level-bar">
            <span class="full-level"></span>
            <span class="level" :style="styleObj"></span>
        </span>
    </router-link>
</template>

<script>

export default {
    props: {
        bouteille: {},
        info: {
            default: null
        }
    },
    computed: {
        styleObj() {
            return {
                width: Math.ceil(this.bouteille.poids_net * 100 / this.bouteille.poids_max) + '%'
            }
        },
        linkToPage() {
            return 'bouteille/' + this.bouteille.id
        },
        classItem() {
            switch (this.bouteille.type) {
                case 'Fluide frigorigène':
                    return 'ff';
                case 'Récupération':
                    return 'rec';
                case 'Transfert':
                    return 'tf';
            }
        }
    },
}

</script>

<style>
.list-bout .item .favori {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 5px 10px;
    background-color: #f9d342;
    color: #222;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    transition: background-color 0.3s, transform 0.2s;
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// BouteilleItem.vue?145b2720